import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type MirrorBoardCardAgingPrefsFragment = (
  { __typename: 'Board' }
  & Pick<Types.Board, 'id' | 'powerUps'>
  & { boardPlugins: Array<(
    { __typename: 'BoardPlugin' }
    & Pick<Types.BoardPlugin, 'id' | 'idPlugin'>
  )>, prefs?: Types.Maybe<(
    { __typename: 'Board_Prefs' }
    & Pick<Types.Board_Prefs, 'cardAging'>
  )> }
);

export const MirrorBoardCardAgingPrefsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MirrorBoardCardAgingPrefs' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boardPlugins' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'idPlugin' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'powerUps' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prefs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cardAging' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseMirrorBoardCardAgingPrefsFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      MirrorBoardCardAgingPrefsFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseMirrorBoardCardAgingPrefsFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<MirrorBoardCardAgingPrefsFragment>,
    'data'
  > {
  data?: MirrorBoardCardAgingPrefsFragment;
}

export const useMirrorBoardCardAgingPrefsFragment = ({
  from,
  returnPartialData,
  ...options
}: UseMirrorBoardCardAgingPrefsFragmentOptions): UseMirrorBoardCardAgingPrefsFragmentResult => {
  const result = Apollo.useFragment<MirrorBoardCardAgingPrefsFragment>({
    ...options,
    fragment: MirrorBoardCardAgingPrefsFragmentDoc,
    fragmentName: 'MirrorBoardCardAgingPrefs',
    from: {
      __typename: 'Board',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as MirrorBoardCardAgingPrefsFragment };
};
